var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBleatLogoSqure(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 158,
    height: 107,
    viewBox: "0 0 158 107",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4657",
    "data-name": "Group 4657",
    transform: "translate(-827 -200)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    "data-name": "Union 2",
    d: "M24.124,106.47V93.162a16.252,16.252,0,0,0,.1-2.621H4a4,4,0,0,1-4-4V4A4,4,0,0,1,4,0H154a4,4,0,0,1,4,4V86.541a4,4,0,0,1-4,4H42.225L27.8,106.47a2.7,2.7,0,0,1-1.84.53A2.694,2.694,0,0,1,24.124,106.47Z",
    transform: "translate(827 200)",
    fill: "#212a42"
  }), /*#__PURE__*/React.createElement("text", {
    id: "bleat",
    transform: "translate(905 262)",
    fill: "#fff",
    fontSize: 50,
    fontFamily: "Butler-Medium, Butler",
    fontWeight: 500,
    letterSpacing: "0.04em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -58,
    y: 0
  }, "bleat")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBleatLogoSqure);
export default __webpack_public_path__ + "static/media/bleat-logo-squre.4cbc5dc7c24c3431bb1588636370c804.svg";
export { ForwardRef as ReactComponent };